import { api } from '@/shared/api/instance';
import type { Log, LogFilters } from '../types/log.types';

const MOCK_LOGS: Log[] = [
  {
    id: '1',
    date: '2025-03-12T14:32:00',
    type: 'api',
    service: 'scat-airlines',
    description: 'Нет ответа от сервера (Timeout)',
    relatedObject: 'Заказ ST-10231',
    status: 'new',
  },
  {
    id: 'ST-10230',
    date: '2025-03-11T10:15:00',
    type: 'booking',
    service: 'air-astana',
    description: '2 взр, 1 реб',
    relatedObject: '685 000 ₸',
    status: 'resolved',
  },
  {
    id: '3',
    date: '2025-03-11T09:20:00',
    type: 'api',
    service: 'flyarystan',
    description: 'Ошибка авторизации (401)',
    relatedObject: 'Заказ ST-10229',
    status: 'new',
  },
  {
    id: '4',
    date: '2025-03-10T16:45:00',
    type: 'payment',
    service: 'payment-gateway',
    description: 'Платеж отклонен банком',
    relatedObject: 'Транзакция #45678',
    status: 'in-progress',
  },
  {
    id: '5',
    date: '2025-03-10T14:30:00',
    type: 'system',
    service: 'booking-system',
    description: 'Превышено время ожидания ответа',
    relatedObject: 'Заказ ST-10228',
    status: 'resolved',
  },
  {
    id: '6',
    date: '2025-03-09T11:10:00',
    type: 'api',
    service: 'scat-airlines',
    description: 'Неверный формат данных в ответе',
    relatedObject: 'Заказ ST-10227',
    status: 'ignored',
  },
  {
    id: '7',
    date: '2025-03-09T08:00:00',
    type: 'user',
    service: 'booking-system',
    description: 'Попытка доступа без авторизации',
    relatedObject: 'Пользователь #1234',
    status: 'new',
  },
  {
    id: '8',
    date: '2025-03-08T17:25:00',
    type: 'booking',
    service: 'air-astana',
    description: '1 взр, 2 детей',
    relatedObject: '450 000 ₸',
    status: 'resolved',
  },
  {
    id: '9',
    date: '2025-03-08T15:50:00',
    type: 'api',
    service: 'payment-gateway',
    description: 'Дублирование платежа',
    relatedObject: 'Транзакция #45677',
    status: 'in-progress',
  },
  {
    id: '10',
    date: '2025-03-08T13:15:00',
    type: 'system',
    service: 'booking-system',
    description: 'Недостаточно памяти на сервере',
    relatedObject: 'Сервер #3',
    status: 'resolved',
  },
];

export async function fetchLogs(filters?: LogFilters): Promise<{ logs: Log[]; total: number }> {
  await new Promise((resolve) => setTimeout(resolve, 300));

  let filteredLogs = [...MOCK_LOGS];

  if (filters?.eventType && filters.eventType !== 'all') {
    filteredLogs = filteredLogs.filter((log) => log.type === filters.eventType);
  }

  if (filters?.service && filters.service !== 'all') {
    filteredLogs = filteredLogs.filter((log) => log.service === filters.service);
  }

  if (filters?.status && filters.status !== 'all') {
    filteredLogs = filteredLogs.filter((log) => log.status === filters.status);
  }

  return {
    logs: filteredLogs,
    total: filteredLogs.length,
  };
}

export const getLogs = async (query: any = {}): Promise<any> => {
  const response = await api.get<any>("/api/v1/event",
    {
      params: query,
    });
  return response.data;
};

export const getFilters = async (): Promise<any> => {
  const response = await api.get<any>("/api/v1/dictionary");
  return response.data;
};